// This file is used to expose functions to playwright through the window object

export const exposeFunctionsToPlaywright = () => {
    if (process.env.VUE_APP_NODE_ENV === 'production') {
        // Not exposing any functions in production to avoid any security issues
        return
    }
}
